var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFigma(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0478516 15.1721C0.0478516 7.13904 6.55994 0.626953 14.593 0.626953C22.626 0.626953 29.1381 7.13904 29.1381 15.1721C29.1381 23.2051 22.626 29.7172 14.593 29.7172C6.55994 29.7172 0.0478516 23.2051 0.0478516 15.1721ZM11.6839 23.8991C13.2905 23.8991 14.593 22.5967 14.593 20.9901V18.0811H11.6839C10.0773 18.0811 8.77491 19.3835 8.77491 20.9901C8.77491 22.5967 10.0773 23.8991 11.6839 23.8991ZM8.77491 15.1721C8.77491 16.7787 10.0773 18.0811 11.6839 18.0811H14.593V12.263H11.6839C10.0773 12.263 8.77491 13.5654 8.77491 15.1721ZM8.77491 9.35401C8.77491 10.9606 10.0773 12.263 11.6839 12.263H14.593V6.44499H11.6839C10.0773 6.44499 8.77491 7.74741 8.77491 9.35401ZM14.593 6.44499V12.263H17.502C19.1086 12.263 20.411 10.9606 20.411 9.35401C20.411 7.74741 19.1086 6.44499 17.502 6.44499H14.593ZM20.411 15.1721C20.411 13.5654 19.1086 12.263 17.502 12.263C15.8954 12.263 14.593 13.5654 14.593 15.1721C14.593 16.7787 15.8954 18.0811 17.502 18.0811C19.1086 18.0811 20.411 16.7787 20.411 15.1721Z",
    className: "icon-primary-color"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFigma);
export default __webpack_public_path__ + "static/media/icon-figma.e24a1012667622caaf13a7d7526771ff.svg";
export { ForwardRef as ReactComponent };